import axios from 'axios';
import Swal from 'sweetalert2';
import { NotificationManager } from 'react-notifications';
import envConfig from '../config/envConfig';
import { hideLoader } from '../utils/loader';

let { baseUrl, posUrl, loanBaseUrl } = envConfig;

const wayagramUrl = `${baseUrl}/wayagram-service`;
const authUrl = `${baseUrl}/auth-serviceV3`;
const smAuthUrl = `${baseUrl}/auth-sm`;
const kycUrl = `${baseUrl}/kyc-servicev2`;
const bvnUrl = `${baseUrl}/bvn-service`;
const cardUrl = `${baseUrl}/card-service`;
const contactUrl = `${baseUrl}/contact-service`;
const billPaymentUrl = `${baseUrl}/billspayment-service`;
const billPaymentUrl2 = `${baseUrl}/billspayment-servicev2`;
const walletUrl = `${baseUrl}/temporal-service`;
const smWalletUrl = `${baseUrl}/temporal-sm-service`;
const paymentRequestUrl = `${baseUrl}/payment-request`;
const accountCreationUrl = `${baseUrl}/account-service`;
const roleUrl = `${baseUrl}/role-service`;
const withdrawalUrl = `${baseUrl}/withdrawal-service`;
const ussdUrl = `${baseUrl}/ussd-service`;
const disputeUrl = `${baseUrl}/social-dispute`;
const socketUrl = `${baseUrl}/chats-service`;
const logUrl = `${baseUrl}/logs-service`;
const wayapayDispute = `${baseUrl}/complaint-service`;
const contentManagementUrl = `${baseUrl}/content-management-service`;
const notificationUrl = `${baseUrl}/notification-service`;
const notificationAggUrl = `${baseUrl}/notification-aggregate`;
const fileResourseUrl = `${baseUrl}/file-resource-service`;
const ussdTopUp = `${baseUrl}/ussd-middle-ware`;
const settlementUrl = `${baseUrl}/settlement-service`;
const commissionUrl = `${baseUrl}/transaction-payment`;
const qrCodeUrl = `${baseUrl}/qrcode-service`;
const referralUrl = `${baseUrl}/referral-service`;
const walletV2 = `${baseUrl}/wallet-v2`;
const nipBvnUrl = `${baseUrl}/nip-bvn-service`;
const fraudUrl = `${baseUrl}/fraud-service`
const statementUrl = `${baseUrl}/statement-service`
const loanUrl = `${baseUrl}/nodejs-loan-module`
// const loanUrl = `${baseUrl}`
const terminalUrl = `${posUrl}/pos-terminal-service`
const terminal = `${posUrl}/pos-terminal`
const integUrl = `${baseUrl}/wayabank-b2b-product-middleware`
const tranv2 = `${baseUrl}/transaction-payment`
const auditUrl = `${baseUrl}/audit-reporting`
const communicationUrl = `${baseUrl}/communication/api/v1`
const autoKycUrl = `${baseUrl}/auto-kyc-service`

const customerUrl = `${baseUrl}/audit-reporting`
const transactionServiceUrl = `${baseUrl}/transaction-service/api/v1`

export const customBaseUrl = {
  terminal,
  terminalUrl,
  statementUrl,
  wayagramUrl,
  authUrl,
  kycUrl,
  bvnUrl,
  cardUrl,
  contactUrl,
  billPaymentUrl,
  billPaymentUrl2,
  ussdUrl,
  walletUrl,
  smWalletUrl,
  paymentRequestUrl,
  accountCreationUrl,
  roleUrl,
  withdrawalUrl,
  disputeUrl,
  socketUrl,
  logUrl,
  wayapayDispute,
  contentManagementUrl,
  notificationUrl,
  notificationAggUrl,
  fileResourseUrl,
  ussdTopUp,
  settlementUrl,
  commissionUrl,
  qrCodeUrl,
  referralUrl,
  walletV2,
  nipBvnUrl,
  fraudUrl,
  smAuthUrl,
  loanUrl,
  integUrl,
  tranv2,
  auditUrl,
  communicationUrl,
  autoKycUrl,
  disputeServiceV3: "https://servicesv3.staging.wayabank.ng/dispute-service",
  transactionServiceUrl,
};
const CLIENT_TYPE = 'ADMIN';
const CLIENT_ID = 'WAYABANK';

export const httpPostBlob = async (url, postBody, customToken = null) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      'Please check your internet',
      'Oops!',
      3000
    );
  }
  const token = customToken || localStorage.token;
  try {
    const res = await axios.post(url, postBody, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    // Check if the response is actually JSON (which usually means an error occurred)
    if (res.data.type === 'application/json') {
      const text = await res.data.text();
      const errorData = JSON.parse(text);
      NotificationManager.error(errorData.message || 'Export failed');
      return null;
    }

    return res.data;
  } catch (error) {
    hideLoader();
    return null;
  }
};

export const httpPost = async (url, postBody, isNotAuth, customToken = null, isClient, other) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      'Please check your internet',
      'Oops!',
      3000
    );
  }

  const token = customToken || localStorage.token;
  const headers = {
    'content-type': 'application/json',
  };

  // Authorization Header
  if (!isNotAuth || isClient) {
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }

  // Client Headers
  if (isClient) {
    headers['CLIENT-TYPE'] = CLIENT_TYPE;
    headers['CLIENT-ID'] = CLIENT_ID;
  }

  // Transaction PIN
  if (other?.pin) {
    headers['Transaction-Pin'] = other.pin;
  }

  try {
    const res = await axios.post(url, postBody, { headers });
    if (res?.data?.error?.message) {
      NotificationManager.error(res?.data?.error?.message, 'Oops!', 5000);
    }
    return res.data;
  } catch (error) {
    hideLoader();
    if (error?.response?.data.error === 'Internal Server Error') {
      return {
        status: false,
        message: error.response.data.message ?? error.response.data.error,
      };
    }
    if (error?.response?.data.message === 'Validation Errors') {
      Object.values(error.response.data.data).map((item) =>
        NotificationManager.error(item, 'Oops!', 5000)
      );
      return error.response?.data;
    }
    const errMsg = error?.response?.data?.error?.message || error?.response?.data?.message;
    if (errMsg) {
      NotificationManager.error(errMsg, 'Oops!', 5000);
    }
    return error.response?.data;
  }
};

export const httpPostUnreloaded = async (
  url,
  postBody,
  otherUrl,
  isNotAuth
) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      'Please check your internet',
      'Oops!',
      3000
    );
  }
  try {
    const res = await axios.post(
      `${url}`,
      postBody,
      !isNotAuth
        ? {
          headers: {
            Authorization: `Bearer ${localStorage.token}`,
            'Content-Type': 'application/x-www-form-urlencoded',
            // 'CLIENT-TYPE': CLIENT_TYPE,
            // 'CLIENT-ID': CLIENT_ID,
          },
        }
        : {}
    );
    return res.data;
  } catch (error) {
    hideLoader();
    return error.response?.data;
  }
};

export const httpPostFormData = async (url, postBody, otherUrl, isNotAuth, customToken = null) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      'Please check your internet',
      'Oops!',
      3000
    );
  }
  const token = customToken || localStorage.token;
  try {
    const res = await axios.post(
      `${url}`,
      postBody,
      !isNotAuth
        ? {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
            // 'CLIENT-TYPE': CLIENT_TYPE,
            // 'CLIENT-ID': CLIENT_ID,
          },
        }
        : {}
    );
    return res.data;
  } catch (error) {
    hideLoader();
    return error.response?.data;
  }
};

export const httpGet = async (url, otherUrl, isNotAuth, isNotHeader, customToken = null, isClient) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      'Please check your internet',
      'Oops!',
      3000
    );
  }
  try {
    const token = customToken || localStorage.token; // Use customToken if provided, else localStorage.token
    const res = await axios.get(
      url,
      !isNotAuth
        ? {
          headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${token}`, // Use the resolved token
            // 'CLIENT-TYPE': CLIENT_TYPE,
            // 'CLIENT-ID': CLIENT_ID,
          },
        }
        : isClient
          ? {
            headers: {
              'content-type': 'application/json',
              Authorization: `Bearer ${token}`, // Use the resolved token
              'CLIENT-TYPE': CLIENT_TYPE,
              'CLIENT-ID': CLIENT_ID,
            },
          }
          : !isNotHeader
            ? {
              headers: {
                // 'CLIENT-TYPE': CLIENT_TYPE,
                // 'CLIENT-ID': CLIENT_ID,
              },
            }
            : {}
    );
    if (res?.data?.error?.message) {
      NotificationManager.error(res?.data?.error?.message, 'Oops!', 5000);
    }
    return res.data;
  } catch (error) {
    hideLoader();
    if (error?.response?.data?.message === 'Validation Errors') {
      Object.values(error?.response?.data?.data).map((item) =>
        Swal.fire('Oops!', item, 'error')
      );
      return error?.response?.data;;
    }
    const errMsg = error?.response?.data?.error?.message || error?.response?.data?.message;
    if (errMsg) {
      NotificationManager.error(errMsg, 'Oops!', 5000);
    }
    return error?.response?.data;
  }
};

export const httpGetPdf = async (url, otherUrl, isNotAuth, isNotHeader, customToken = null) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      'Please check your internet',
      'Oops!',
      3000
    );
  }
  const token = customToken || localStorage.token;
  try {
    const res = await axios.get(
      url,
      !isNotAuth
        ? {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/pdf',
            // 'CLIENT-TYPE': CLIENT_TYPE,
            // 'CLIENT-ID': CLIENT_ID,
          },
        }
        : {}
    );
    if (res?.data?.error?.message) {
      NotificationManager.error(res?.data?.error?.message, 'Oops!', 5000);
    }
    return res.data;
  } catch (error) {
    hideLoader();
    if (error?.response?.data?.message === 'Validation Errors') {
      Object.values(error?.response?.data?.data).map((item) =>
        Swal.fire('Oops!', item, 'error')
      );
      return error?.response?.data;;
    }
    return error?.response?.data;
  }
};

export const httpGetBlob = async (url, customToken = null) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      'Please check your internet',
      'Oops!',
      3000
    );
  }
  const token = customToken || localStorage.token;
  try {
    const res = await axios.get(url, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  } catch (error) {
    hideLoader();
    return null;
  }
};

export const httpPut = async (url, postBody, otherUrl, isNotAuth, isClient) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      'Please check your internet',
      'Oops!',
      3000
    );
  }
  try {
    const res = await axios.put(
      `${url}`,
      postBody,
      !isNotAuth
        ? {
          headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${localStorage.token}`,
          },
        }
        : isClient
          ? {
            headers: {
              'content-type': 'application/json',
              Authorization: `Bearer ${localStorage.token}`,
              'CLIENT-TYPE': CLIENT_TYPE,
              'CLIENT-ID': CLIENT_ID,
            },
          }
          : {}
    );
    if (res?.data?.error?.message) {
      NotificationManager.error(res?.data?.error?.message, 'Oops!', 5000);
    }
    return res.data;
  } catch (error) {
    hideLoader();
    if (error.response.data.message === 'Validation Errors') {
      return {
        status: false,
        message: error.response?.data.data[0],
      };
    }
    const errMsg = error?.response?.data?.error?.message || error?.response?.data?.message;
    if (errMsg) {
      NotificationManager.error(errMsg, 'Oops!', 5000);
    }
    return error.response?.data;
  }
};

export const httpPatch = async (url, postBody, otherUrl, isNotAuth, customToken = null) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      'Please check your internet',
      'Oops!',
      3000
    );
  }
  const token = customToken || localStorage.token;
  try {
    const res = await axios.patch(
      `${url}`,
      postBody,
      !isNotAuth
        ? {
          headers: {
            Authorization: `Bearer ${token}`,
            // 'CLIENT-TYPE': CLIENT_TYPE,
            // 'CLIENT-ID': CLIENT_ID,
          },
        }
        : {}
    );
    if (res?.data?.error?.message) {
      NotificationManager.error(res?.data?.error?.message, 'Oops!', 5000);
    }
    return res.data;
  } catch (error) {
    const errMsg = error?.response?.data?.error?.message || error?.response?.data?.message;
    if (errMsg) {
      NotificationManager.error(errMsg, 'Oops!', 5000);
    }
    return error.response?.data;
  }
};

export const httpDelete = async (url, data, otherUrl, isNotAuth) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      'Please check your internet',
      'Oops!',
      3000
    );
  }
  try {
    const res = await axios.delete(
      `${url}`,
      !isNotAuth
        ? {
          headers: {
            Authorization: `Bearer ${localStorage.token}`,
            // 'CLIENT-TYPE': CLIENT_TYPE,
            // 'CLIENT-ID': CLIENT_ID,
          },
          data,
        }
        : {}
    );
    if (res?.data?.error?.message) {
      NotificationManager.error(res?.data?.error?.message, 'Oops!', 5000);
    }
    return res.data;
  } catch (error) {
    hideLoader();
    const errMsg = error?.response?.data?.error?.message || error?.response?.data?.message;
    if (errMsg) {
      NotificationManager.error(errMsg, 'Oops!', 5000);
    }
    return error.response?.data;
  }
};
